import * as React from 'react';
import styled from 'styled-components';

import { Icon, Text } from '@amzn/storm-ui';
import { success } from '../../../../colors';
import { useAccountDropdownBundle } from '../../../../providers/PantherLocalizationProvider';
import { AccountGroup } from '@amzn/aac-chrome-internal-api';

type IA2AccountFilteredMessage = {
  accountTypeList: AccountGroup[];
};

const GreenDiv = styled.div`
  color: ${success};
  display: inline-block;
  padding-top: ${({ theme }) => theme.spacing.base};
`;

export const AccountFilteredMessage = ({ message }) => (
  <GreenDiv>
    <Icon type="check" size="xs" />{' '}
    <Text fontSize="small" type="span">
      {message}
    </Text>
  </GreenDiv>
);

export const IA2AccountFilteredMessage: React.FC<IA2AccountFilteredMessage> = ({
  accountTypeList,
}) => {
  const numberOfAccountsDisplayed = accountTypeList.reduce(
    (acc, accountType) => acc + accountType.accounts.length,
    0,
  );
  const bundle = useAccountDropdownBundle();
  const message = bundle.formatMessage(
    'account-dropdown-filterd-accounts-display',
    {
      numAccounts: numberOfAccountsDisplayed,
    },
  );
  return <AccountFilteredMessage message={message} />;
};
